import {
  ClipboardCheck, Warehouse, Factory, ShieldCheck, RefreshCw,
  Wrench, Ruler, MessageSquareWarning, FileSearch, GraduationCap,
  Rocket, BarChart3, GitBranch, Cpu, Zap,
  UserPlus, AlertTriangle, Truck, MessageCircleWarning, ClipboardList,
  FileText, Award, LayoutDashboard, Star, CheckCircle,
  Lock, Globe, Monitor,
} from 'lucide-react';

const searchEntries = [
  // ─── FACTORY OS APPS ───
  {
    name: 'Incoming Quality',
    category: 'Mushin Factory OS',
    path: '/products/factory-os#incoming-quality',
    icon: ClipboardCheck,
    desc: 'Incoming inspections, supplier approvals, and sampling standards.',
    keywords: ['incoming quality', 'iqc', 'incoming inspection', 'grn', 'supplier approval', 'sampling', 'incoming material', 'receiving inspection', 'material inspection', 'pdi', 'mtc', 'certificate', 'inward quality'],
  },
  {
    name: 'Digital Stores',
    category: 'Mushin Factory OS',
    path: '/products/factory-os#digital-stores',
    icon: Warehouse,
    desc: 'Inventory, FIFO, bin locations, and material lots in real time.',
    keywords: ['digital stores', 'stores', 'fifo', 'bin', 'lot', 'inventory', 'rack', 'material', 'warehouse', 'stock', 'store management', 'bin placement', 'shelf life', 'material issue', 'barcode inventory'],
  },
  {
    name: 'Production Execution',
    category: 'Mushin Factory OS',
    path: '/products/factory-os#production-execution',
    icon: Factory,
    desc: 'Output, rejections, and operator-wise production across shifts.',
    keywords: ['production', 'production execution', 'output', 'rejection', 'red bin', 'shift report', 'hourly report', 'daily production', 'operator performance', 'production report', 'production reports', 'cycle time', 'man machine matrix', 'wages', 'operator skill', 'machine startup'],
  },
  {
    name: 'Quality Management',
    category: 'Mushin Factory OS',
    path: '/products/factory-os#quality-management',
    icon: ShieldCheck,
    desc: 'Control plans, inspections, SPC, and digital quality workflows.',
    keywords: ['quality', 'quality management', 'spc', 'control plan', 'checksheet', 'e-checksheet', 'fmea', 'inspection', 'quality checks', 'quality check', 'in-process', 'final inspection', 'pdi', 'poka-yoke', 'layered audit', 'dock audit', '5s', 'misp', 'pqct', 'pfd', 'drawing', 'work instruction', 'document control', 'quality documentation', 'mr', 'management representative', 'standards', 'cqi'],
  },
  {
    name: 'Change Management',
    category: 'Mushin Factory OS',
    path: '/products/factory-os#change-management',
    icon: RefreshCw,
    desc: '4M changes, abnormalities, and corrective action workflows.',
    keywords: ['change management', '4m', '4m change', 'abnormality', 'violation', 'corrective action', 'evidence collection', 'retro', 'suspected', 'setup evidence', 'man machine material method'],
  },
  {
    name: 'Maintenance',
    category: 'Mushin Factory OS',
    path: '/products/factory-os#maintenance',
    icon: Wrench,
    desc: 'Machine history, PM schedules, breakdowns, and asset health.',
    keywords: ['maintenance', 'preventive maintenance', 'predictive maintenance', 'breakdown', 'pm', 'spare parts', 'mttr', 'mtbf', 'machine history', 'tool die mould', 'asset', 'machine health', 'energy', 'diesel'],
  },
  {
    name: 'Calibration Lab',
    category: 'Mushin Factory OS',
    path: '/products/factory-os#calibration-lab',
    icon: Ruler,
    desc: 'Instruments, calibration due dates, certificates, and MSA records.',
    keywords: ['calibration', 'calibration lab', 'instrument', 'gauge', 'msa', 'calibration certificate', 'calibration due', 'measuring', 'measurement system analysis'],
  },
  {
    name: 'Complaints & CAPA',
    category: 'Mushin Factory OS',
    path: '/products/factory-os#complaints-capa',
    icon: MessageSquareWarning,
    desc: 'Customer complaints, quality alerts, 8D actions, and closure tracking.',
    keywords: ['capa', 'complaints', 'complaint', '8d', 'customer complaint', 'quality alert', 'pareto', 'ptdb', 'problem to daily board', 'corrective action', 'corrective', 'feedback', 'repeat complaint', 'non-conformance', 'nc'],
  },
  {
    name: 'Audit Management',
    category: 'Mushin Factory OS',
    path: '/products/factory-os#audit-management',
    icon: FileSearch,
    desc: 'Internal, process, product, dock, and layered audits digitally.',
    keywords: ['audit', 'audits', 'audit management', 'internal audit', 'process audit', 'product audit', 'dock audit', 'layered audit', 'audit finding', 'audit closure', 'digitize audits', 'how to digitize audits'],
  },
  {
    name: 'Training / DOJO',
    category: 'Mushin Factory OS',
    path: '/products/factory-os#training-dojo',
    icon: GraduationCap,
    desc: 'Skill tracking, training plans, assessments, and OJT records.',
    keywords: ['training', 'dojo', 'training dojo', 'skill matrix', 'skill', 'tni', 'training need', 'ojt', 'induction', 'skill evaluation', 'test paper', 'vr training', 'digital dojo', 'attendance'],
  },
  {
    name: 'NPD / APQP',
    category: 'Mushin Factory OS',
    path: '/products/factory-os#npd-apqp',
    icon: Rocket,
    desc: 'APQP milestones, PPAP status, drawings, and project progress.',
    keywords: ['apqp', 'ppap', 'npd', 'new product development', 'advanced product quality planning', 'project', 'drawing', 'milestone', 'apqp matrix', 'time plan'],
  },
  {
    name: 'Management Dashboards',
    category: 'Mushin Factory OS',
    path: '/products/factory-os#management-dashboards',
    icon: BarChart3,
    desc: 'KPI trends, rejection analysis, department health, and reports.',
    keywords: ['dashboard', 'dashboards', 'management dashboard', 'kpi', 'mis', 'reporting', 'reports', 'ppm', 'rejection pareto', 'department health', 'alerts', 'notifications', 'email summary'],
  },
  {
    name: 'End-to-End Traceability',
    category: 'Mushin Factory OS',
    path: '/products/factory-os#traceability',
    icon: GitBranch,
    desc: 'Material, process, inspection, and dispatch in one traceability chain.',
    keywords: ['traceability', 'end-to-end traceability', 'batch traceability', 'lot traceability', 'genealogy', 'digital genealogy', 'forward trace', 'backward trace', 'barcode', 'part traceability', 'material traceability', 'need batch traceability', 'track', 'trace'],
  },
  {
    name: 'IoT & Machine Data',
    category: 'Mushin Factory OS',
    path: '/products/factory-os#iot-machine-data',
    icon: Cpu,
    desc: 'Machine signals, OEE, runtime, alarms, and live line data.',
    keywords: ['iot', 'iot 4.0', 'machine data', 'oee', 'plc', 'sensor', 'andon', 'runtime', 'downtime', 'machine monitoring', 'live dashboard', 'shopfloor', 'want machine data', 'improve oee', 'machine signals', 'alarms', 'poka-yoke health'],
  },
  {
    name: 'Energy Monitoring',
    category: 'Mushin Factory OS',
    path: '/products/factory-os#energy-monitoring',
    icon: Zap,
    desc: 'Energy use, machine-wise consumption, and cost visibility.',
    keywords: ['energy', 'energy monitoring', 'diesel', 'consumption', 'power', 'electricity', 'cost visibility', 'machine energy'],
  },

  // ─── VENDOR CONNECT APPS ───
  {
    name: 'Supplier Onboarding',
    category: 'Mushin Vendor Connect',
    path: '/products/vendor-connect#supplier-onboarding',
    icon: UserPlus,
    desc: 'Supplier registration, qualification, and approval workflows.',
    keywords: ['supplier onboarding', 'onboarding', 'vendor onboarding', 'supplier registration', 'supplier qualification', 'vendor qualification', 'new supplier', 'vendor registration'],
  },
  {
    name: 'Line Incidents',
    category: 'Mushin Vendor Connect',
    path: '/products/vendor-connect#line-incidents',
    icon: AlertTriangle,
    desc: 'Supplier-linked production issues and faster resolution.',
    keywords: ['line incidents', 'line incident', 'track line incidents', 'line stoppage', 'incoming defect', 'containment', 'severity', 'supplier defect'],
  },
  {
    name: 'DOL Management',
    category: 'Mushin Vendor Connect',
    path: '/products/vendor-connect#dol-management',
    icon: Truck,
    desc: 'Delivery commitments, deviations, and follow-up actions.',
    keywords: ['dol', 'dol management', 'delivery', 'otd', 'on-time delivery', 'dispatch', 'shortage', 'overdue', 'shipment', 'po commitment'],
  },
  {
    name: 'Supplier Complaints',
    category: 'Mushin Vendor Connect',
    path: '/products/vendor-connect#supplier-complaints',
    icon: MessageCircleWarning,
    desc: 'Supplier issues, responses, and closure records.',
    keywords: ['supplier complaints', 'vendor complaints', 'supplier complaint', 'supplier issue', 'vendor issue', 'need supplier complaint software', 'supplier sla', 'repeat issue', 'supplier escalation'],
  },
  {
    name: 'Supplier Audits',
    category: 'Mushin Vendor Connect',
    path: '/products/vendor-connect#supplier-audits',
    icon: ClipboardList,
    desc: 'Plan, conduct, score, and review supplier audits digitally.',
    keywords: ['supplier audits', 'vendor audits', 'supplier audit', 'vendor audit', 'audit score', 'audit checklist', 'nc observation', 'compliance gap', 'vda 6.3'],
  },
  {
    name: 'RFQ to LOI',
    category: 'Mushin Vendor Connect',
    path: '/products/vendor-connect#rfq-to-loi',
    icon: FileText,
    desc: 'Sourcing progress from quotation to commercial finalization.',
    keywords: ['rfq', 'loi', 'rfq to loi', 'sourcing', 'quotation', 'quote comparison', 'commercial', 'negotiation', 'vendor shortlisting', 'procurement'],
  },
  {
    name: 'Certificate Management',
    category: 'Mushin Vendor Connect',
    path: '/products/vendor-connect#certificate-management',
    icon: Award,
    desc: 'Certificates, expiry dates, and compliance records.',
    keywords: ['certificate', 'certificates', 'certificate management', 'supplier certificates', 'iatf', 'iso', 'nabl', 'expiry', 'compliance', 'how to track certificates', 'certificate expiry'],
  },
  {
    name: 'Supplier Dashboards',
    category: 'Mushin Vendor Connect',
    path: '/products/vendor-connect#supplier-dashboards',
    icon: LayoutDashboard,
    desc: 'Supplier status, pending actions, and performance visibility.',
    keywords: ['supplier dashboards', 'supplier dashboard', 'vendor dashboard', 'supplier health', 'vendor status', 'supplier performance', 'vendor performance', 'control tower'],
  },
  {
    name: 'Ratings & Scorecards',
    category: 'Mushin Vendor Connect',
    path: '/products/vendor-connect#ratings-scorecards',
    icon: Star,
    desc: 'PPM, audit scores, and supplier performance in one place.',
    keywords: ['ratings', 'scorecards', 'ratings scorecards', 'supplier rating', 'vendor rating', 'ppm', 'supplier ranking', 'supplier segmentation', 'preferred', 'conditional', 'blocked'],
  },
  {
    name: 'Corrective Actions',
    category: 'Mushin Vendor Connect',
    path: '/products/vendor-connect#corrective-actions',
    icon: CheckCircle,
    desc: 'Supplier CAPA actions tracked through closure.',
    keywords: ['corrective actions', 'supplier capa', 'vendor capa', 'supplier corrective', 'action closure', 'linked issues'],
  },

  // ─── PAGES ───
  {
    name: 'Mushin Factory OS',
    category: 'Product',
    path: '/products/factory-os',
    icon: ShieldCheck,
    desc: 'The operating system for factory operations. 15 connected apps for plant quality, execution, and traceability.',
    keywords: ['factory os', 'mushin factory os', 'plant quality', 'factory operations', 'operating system', 'factory software', 'plant digitization', 'factory digitization'],
  },
  {
    name: 'Mushin Vendor Connect',
    category: 'Product',
    path: '/products/vendor-connect',
    icon: UserPlus,
    desc: 'Supplier quality and vendor governance platform. 10 apps for complete supplier lifecycle management.',
    keywords: ['vendor connect', 'mushin vendor connect', 'supplier quality', 'vendor governance', 'supplier management', 'vendor management', 'sqe', 'supplier lifecycle'],
  },
  {
    name: 'Manufacturing 4.0',
    category: 'Page',
    path: '/manufacturing-4',
    icon: Cpu,
    desc: 'Industry 4.0, IoT connectivity, end-to-end traceability architecture, and the connected factory.',
    keywords: ['manufacturing 4.0', 'industry 4.0', 'iot 4.0', 'connected factory', 'paperless factory', 'digital factory', 'factory paperless', 'smart factory', 'industry 4', 'fourth industrial revolution', 'digital backbone'],
  },
  {
    name: 'Security & Deployment',
    category: 'Page',
    path: '/security',
    icon: Lock,
    desc: 'AWS cloud infrastructure, encryption, RBAC, MFA, data protection, and deployment architecture.',
    keywords: ['security', 'deployment', 'aws', 'cloud', 'encryption', 'rbac', 'mfa', 'role based access', 'data protection', 'backup', 'uptime', 'infrastructure'],
  },
  {
    name: 'About Mushin',
    category: 'Page',
    path: '/about',
    icon: Globe,
    desc: 'Our story, leadership team, and manufacturing presence across India.',
    keywords: ['about', 'about mushin', 'company', 'team', 'founders', 'leadership', 'gurugram', 'india', 'who is mushin'],
  },
  {
    name: 'Contact Us',
    category: 'Page',
    path: '/contact',
    icon: MessageCircleWarning,
    desc: 'Get in touch, book a demo, or request a quote.',
    keywords: ['contact', 'demo', 'book demo', 'quote', 'get in touch', 'sales', 'pricing', 'reach us'],
  },

  // ─── INDUSTRY PAGES ───
  {
    name: 'Automotive',
    category: 'Industry',
    path: '/industries/automotive',
    icon: Factory,
    desc: 'IATF 16949, VDA audits, layered quality, and full plant digitization for automotive.',
    keywords: ['automotive', 'auto', 'iatf', 'iatf 16949', 'vda', 'vda 6.3', 'maruti', 'vsa', 'tier 1', 'tier 2', 'oem', 'car', 'vehicle', 'automotive standards'],
  },
  {
    name: 'Aerospace',
    category: 'Industry',
    path: '/industries/aerospace',
    icon: Rocket,
    desc: 'AS9100, documentation control, deviation handling, and audit readiness for aerospace.',
    keywords: ['aerospace', 'as9100', 'aviation', 'defence', 'defense', 'space', 'aircraft'],
  },
  {
    name: 'Pharmaceuticals',
    category: 'Industry',
    path: '/industries/pharmaceuticals',
    icon: ShieldCheck,
    desc: 'GMP, Schedule M, batch traceability, SOP compliance, and inspection readiness.',
    keywords: ['pharma', 'pharmaceuticals', 'pharmaceutical', 'gmp', 'schedule m', 'batch', 'sop', 'drug', 'medicine', 'api'],
  },
  {
    name: 'FMCG',
    category: 'Industry',
    path: '/industries/fmcg',
    icon: Factory,
    desc: 'Quality checkpoints, line visibility, and standardised workflows for FMCG.',
    keywords: ['fmcg', 'consumer goods', 'food', 'beverage', 'packaging', 'consumer'],
  },
  {
    name: 'Export Manufacturing',
    category: 'Industry',
    path: '/industries/export-manufacturing',
    icon: Globe,
    desc: 'Quality documentation, traceability, and audit readiness for global buyers.',
    keywords: ['export', 'export manufacturing', 'global', 'international', 'buyer compliance', 'export qa'],
  },

  // ─── CAPABILITY / CONCEPT ENTRIES ───
  {
    name: 'Paperless Factory',
    category: 'Capability',
    path: '/manufacturing-4',
    icon: Monitor,
    desc: 'Eliminate paper from shopfloor operations with digital workflows, checksheets, and records.',
    keywords: ['paperless', 'paperless factory', 'no paper', 'digital records', 'eliminate paper', 'go paperless', 'paper free'],
  },
  {
    name: 'End-to-End Traceability',
    category: 'Manufacturing 4.0',
    path: '/manufacturing-4#traceability',
    icon: GitBranch,
    desc: 'The complete traceability architecture: forward trace, backward trace, and digital genealogy.',
    keywords: ['end to end traceability', 'traceability architecture', 'traceability chain', 'full traceability', 'complete traceability', 'material to dispatch'],
  },
  {
    name: 'ERP Integration',
    category: 'Capability',
    path: '/products/factory-os',
    icon: RefreshCw,
    desc: 'Mushin integrates with SAP, Oracle, and other ERP systems for seamless data flow.',
    keywords: ['erp', 'sap', 'oracle', 'erp integration', 'data sync', 'integration'],
  },
];

export default searchEntries;
